import type { UnwindSource } from "@/hooks/use-unwind-form";

type Props = {
  readonly value: UnwindSource;
  readonly onChange: (s: UnwindSource) => void;
};

const ZapIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);

const WalletIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
  >
    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/>
    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/>
    <path d="M18 12a2 2 0 0 0 0 4h4v-4z"/>
  </svg>
);

type Opt = {
  readonly id: UnwindSource;
  readonly icon: React.ReactNode;
  readonly label: string;
  readonly hint: string;
};

const OPTIONS: ReadonlyArray<Opt> = [
  {
    id: "collateral",
    icon: <ZapIcon />,
    label: "Sell collateral (flash loan)",
    hint: "Contract flash-loans, swaps some CADC for USDC, returns the rest.",
  },
  {
    id: "wallet",
    icon: <WalletIcon />,
    label: "USDC from wallet",
    hint: "You supply the USDC used to repay debt.",
  },
];

export const UnwindSourceSelect = ({ value, onChange }: Props) => {
  const visible = OPTIONS;
  return (
  <section>
    <div className="flex items-baseline justify-between mb-3">
      <h3>Repay source</h3>
    </div>
    <div role="radiogroup" aria-label="Repay source" className="space-y-2">
      {visible.map((opt) => {
        const active = value === opt.id;
        return (
          <button
            key={opt.id}
            role="radio"
            aria-checked={active}
            type="button"
            onClick={() => onChange(opt.id)}
            className="w-full text-left px-4 py-3 rounded-[var(--radius-md)] transition-opacity hover:opacity-90"
            style={{
              border: active
                ? "1px solid var(--ink-2)"
                : "1px solid var(--line-2)",
              background: active ? "var(--surface-2)" : "transparent",
            }}
          >
            <div
              className="flex items-center gap-2 font-sans text-[13px]"
              style={{
                color: active ? "var(--ink-1)" : "var(--ink-2)",
                fontWeight: 500,
              }}
            >
              {opt.icon}
              {opt.label}
            </div>
            <div
              className="font-sans text-[11px] mt-1"
              style={{ color: "var(--ink-3)" }}
            >
              {opt.hint}
            </div>
          </button>
        );
      })}
    </div>
  </section>
  );
};
